import { render } from "./VendorInvoice.vue?vue&type=template&id=0fc16053"
import script from "./VendorInvoice.vue?vue&type=script&lang=js"
export * from "./VendorInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__